import React from "react";
import { Link } from "react-router-dom";
import useFadeIn from "./UseFadeIn.js";

import TwoImages from "../Utils/TwoImages.js";

export default function Building({
  title,
  imageSrc1,
  imageSrc2,
  imagePosition = "left",
  fadeIn = false,
  children,
}) {
  const { domRef, isVisible } = useFadeIn();

  return (
    <>
      <section className="feature-area2 p-relative fix pb-5 pt-3" ref={domRef}>
        <div className="container">
          <div
            className={`row justify-content-start ${fadeIn ? `fade-in-${imagePosition}-section` : ""}  ${isVisible ? "is-visible" : ""}`}
          >
            <div className={`col-lg-5 order-2 order-lg-${imagePosition === 'left' ? '1' : '2'}`}>
              <TwoImages
                imgSrc1={imageSrc1}
                imgSrc2={imageSrc2}
                image1Style={null}
                image2Style={{
                  position: "absolute",
                  bottom: "0px",
                  right: "0px",
                  width: "60%",
                  height: "auto",
                  borderLeft: "10px solid white",
                  borderTop: "10px solid white",
                }}
              />
            </div>
            <div className={`col-lg-7 order-1 mb-2 order-lg-${imagePosition === 'left' ? '2' : '1'}`}>
              <div className="feature-content s-about-content">
                <div className="feature-title pb-20">
                  <h3>{title}</h3>
                </div>
                {children}
                <div className="slider-btn">
                  <Link to="/rooms" className="btn ss-btn smoth-scroll">
                    Zobacz pokoje
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}